
module.exports = require('./socket');

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = require('engine.io-parser');



/*****************
 ** WEBPACK FOOTER
 ** ./~/wilddog/~/engine.io-client/lib/index.js
 ** module id = 415
 ** module chunks = 1
 **/